import countries from 'i18n-iso-countries'
import enLocaleData from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(enLocaleData)

// Function to get country name from country code
const getCountryName = (countryCode: string, locale: string) => {
  const value = countries.getName(countryCode.toUpperCase(), locale)

  return value
}

export {
  getCountryName
}
